import { useStyle } from "./style";
import { useDeliveryStatusButton } from "./use-delivery-status";
import { ITaskCategoryLabelProps } from "./utils/interfaces";
import { UpdateDeliveryStatusModal } from "./delivery-status-modal/delivery-status-modal";
import { DocumentDeliveryStatuses } from "./delivery-status-modal/use-delivery-status-modal";
import { useClientContactsList } from "@/hooks/use-client-contacts";
import { GoMakeDeleteModal } from "@/components";
import { ModalType } from "@/enums";

const ClickableStatusButton = ({
  document,
  documentType,
  onClickOpenMoveOrderToReadyModal,
  getAllQuotes,
}: ITaskCategoryLabelProps) => {
  const {
    t,
    openDeliveryModal,
    onCloseDeliveryModal,
    getDocumentDeliveryItems,
    _renderDeliveryStatusColor,
    renderTableRows,
    editableQuantities,
    setEditableQuantities,
    setDocumentItems,

    onCloseDeleteModal,
    selectedItem,
    removeDocumentDeliveryItem,
    openDeleteModal,
  } = useDeliveryStatusButton();
  const { getClientContacts, clientContacts } = useClientContactsList();


  const { classes } = useStyle({
    color: _renderDeliveryStatusColor(document?.deliveryStatus),
  });

  const handleChangeStatusClick = () => {
    getDocumentDeliveryItems(documentType, document?.id);
    getClientContacts(document?.customerId);
  };

  return (
    <>
      <span onClick={handleChangeStatusClick} style={classes.spanStyle}>
        {t(
          `sales.documentDeliveries.${DocumentDeliveryStatuses[document?.deliveryStatus]
          }`
        )}
      </span>
      <UpdateDeliveryStatusModal
        openModal={openDeliveryModal}
        onCloseModal={onCloseDeliveryModal}
        document={document}
        documentItems={renderTableRows()}
        editableQuantities={editableQuantities}
        setEditableQuantities={setEditableQuantities}
        setDocumentItems={setDocumentItems}
        clientContacts={clientContacts}
        documentType={documentType}
        documentId={document?.id}
        onClickOpenMoveOrderToReadyModal={onClickOpenMoveOrderToReadyModal}
        getAllQuotes={getAllQuotes}
      />
      <GoMakeDeleteModal
        modalType={ModalType.DELETE}
        openModal={openDeleteModal}
        onClose={onCloseDeleteModal}
        onClickDelete={() => removeDocumentDeliveryItem(selectedItem)}
      />
    </>
  );
};

export { ClickableStatusButton };
